import './App.css';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import Sidebar from './components/Sidebar';
import { BrowserRouter } from 'react-router-dom';
import Rotas from './routes';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Sidebar />
           {/*<Navbar />*/}
            <Rotas />
          {/* <Footer /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
